module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Loading Sequence","save":"Save"},"no":{"title":"Lasterekkefølge","save":"Lagre"}}')
  delete Component.options._Ctor
}
